import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { toast } from 'react-toastify';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';

const AddSimData = ({ history, location }) => {

    const access_token = useSelector(state => state.auth.access_token);
    const [submitLoading, setSubmitLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        id: "",
        provider_name: "",
        sim_number: "",
        mobile_number: "",
        network_type: "",
        plan :"",
        notes :""

    })
    const [isEditMode, setIsEditMode] = useState(false)

    const backToListing = () => {
        history.push({ pathname: '/sim' });

    }
    useEffect(() => {
        initialFormData()
    }, []);

    const initialFormData = () => {
        if (location?.state?.editSimData) {
            console.log(location?.state?.editSimData);

            setFormData({
                provider_name: location.state.editSimData.provider_name || "",
                mobile_number: location.state.editSimData.mobile_number || "",
                sim_number: location.state.editSimData.sim_number || "",
                network_type: location.state.editSimData.network_type || "",
                id: location.state.editSimData.id || "",
                plan: location.state.editSimData.plan || "",
                notes: location.state.editSimData.notes || "",

            })
            setIsEditMode(true)
        }
    }
    const submitDataForm = (e) => {
        e.preventDefault();

        setSubmitLoading(true)
        if (isEditMode == true) {
            HttpAPICall.withAthorization('PUT', BACKOFFICE_BASE_URL + '/sim_edit', access_token, {}, formData, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                history.push({ pathname: '/sim', state: { id: formData.id }});

            }).then(() => setSubmitLoading(false))

        } else {
            HttpAPICall.withAthorization('POST', BACKOFFICE_BASE_URL + '/sim_add', access_token, {}, formData, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                backToListing();
            }).then(() => setSubmitLoading(false));

        }
    }
    const formInputHandler = (e) => {
        setFormData(pre => ({ ...pre, [e.target.name]: e.target.value }));
    };

    const formDatajsx = () => {
        return (
            <>
                <form className="bg-white p-3" onSubmit={submitDataForm} id="saveResourceForm">
                    {loading ? <Loader />
                        :
                        <>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">Netwrok Provider</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="provider_name"
                                        type="text"
                                        value={formData.provider_name}
                                        className="form-control"
                                        autoComplete="off"
                                        required={true}
                                        onChange={formInputHandler}
                                        placeholder="Please enter Network Provider"

                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">Netwrok Type</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="network_type"
                                        type="text"
                                        value={formData.network_type}
                                        className="form-control"
                                        autoComplete="off"
                                        required={true}
                                        onChange={formInputHandler}
                                        placeholder="Please enter Network Type"

                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">ICCID</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="sim_number"
                                        type="number"
                                        value={formData.sim_number}
                                        className="form-control"
                                        autoComplete="off"
                                        required={true}
                                        onChange={formInputHandler}
                                        placeholder="Please enter ICCID"

                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">Mobile Number</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="mobile_number"
                                        type="number"
                                        value={formData.mobile_number}
                                        className="form-control"
                                        autoComplete="off"
                                        required={true}
                                        onChange={formInputHandler}
                                        placeholder="Please enter Mobile Number"

                                    />
                                </div>
                            </div>
                             <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label ">Plan</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="plan"
                                        type="text"
                                        value={formData.plan}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={formInputHandler}
                                        placeholder="Please enter Plan"

                                    />
                                </div>
                            </div>
                             <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label ">Notes</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="notes"
                                        type="text"
                                        value={formData.notes}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={formInputHandler}
                                        placeholder="Please enter Notes"

                                    />
                                </div>
                            </div>
                        </>
                    }
                    <div className="col-12 text-end fixed_footer">
                        <button type="button" className="btn btn-secondary mx-3" onClick={backToListing} disabled={submitLoading}>Cancel</button>
                        <button type="submit" className="btn btn-primary mx-2" disabled={submitLoading}>
                            Save {submitLoading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                        </button>
                    </div>
                </form>
            </>
        );
    };
    const addManufacturerJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    <div className="col-12">
                        <h3> {isEditMode ? "Edit " : "Add "} SimData</h3>
                        <div className="text-end mt15">
                            <>
                                <button type="button" className="btn btn-secondary" onClick={backToListing}>
                                    <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-action" />
                                </button>
                            </>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', 'col-12'].join(' ')}>{formDatajsx()}</div>
                    </div>
                </div>
            </>
        );
    };
    return (
        <ApplicationLayout>
            <Helmet><title>Add Device</title></Helmet>
            {addManufacturerJsx()}
        </ApplicationLayout>
    );
};

export default AddSimData;